import { getAuth } from "firebase/auth";

export const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:3001";

async function getAuthHeaders(): Promise<Record<string, string>> {
	const user = getAuth().currentUser;
	if (!user || user.isAnonymous) return {};
	const token = await user.getIdToken();
	return { Authorization: `Bearer ${token}` };
}

export async function authFetch(path: string, options: RequestInit = {}): Promise<Response> {
	const authHeaders = await getAuthHeaders();
	return fetch(`${API_URL}${path}`, {
		...options,
		headers: {
			...options.headers,
			...authHeaders,
		},
	});
}
